import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ViewConfigurationService {
  // subjects
  private configurationDataToSaveSubject = new BehaviorSubject<any>(null);

  // observables
  configurationDataToSave$ = this.configurationDataToSaveSubject.asObservable();

  // store
  public updateConfigurationDataToSave(configurationData: any): void {
    // clone input in order to avoid mutation further down the line
    const clonedConfigs = structuredClone(configurationData);
    this.configurationDataToSaveSubject.next(clonedConfigs);
  }
}
